import TraceAudit from "./-traceAudit";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/opr/traceAudit")({
  staticData: {
    menuLabel: "溯源审核",
    showInMenu: true,
    menuGroup: "/opr",
    menuOrder: 3,
  },
  component: TraceAudit,
});
